import { DocumentsContainer } from "./DocumentsContainer";
import { CloudUpload, WarningSquare } from "@carbon/icons-react";
import { Button } from "../../../../atom/Button";
import React from "react";
import { ParticipantFile } from "../../../../../types/components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../utils/consts/routes";

interface MissingDocumentsProps {
  missingDocuments: ParticipantFile[];
}

export const MissingDocuments: React.FC<MissingDocumentsProps> = ({ missingDocuments }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <DocumentsContainer icon={WarningSquare} title={t("Missing")}>
      <div className="flex flex-col gap-4">
        {missingDocuments.map(({ type }) => (
          <p key={type.code} className="font-medium tracking-[0.2px] text-black">
            {type.name}
          </p>
        ))}
      </div>
      <Button
        onClick={() => navigate(ROUTES.documents)}
        label={t("Add Documents")}
        type="tertiary"
        additionalClassName="w-full mt-32"
        leftIcon={<CloudUpload size={24} />}
      />
    </DocumentsContainer>
  );
};
